<template>
  <div class="account-settings-content user-logs tab-pane fade" id="user-activity" role="tabpanel" aria-labelledby="user-activity-tab">
    <h2>{{$t('account_settings.company_user_activity.user_activity')}}</h2>
    <table class="table">
      <thead>
      <tr>
        <th>{{$t('account_settings.company_user_activity.event')}}</th>
        <th>{{$t('account_settings.company_user_activity.date')}}</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="activity in user_activities">
          <td>
            <span class="event">{{activity.who}}</span>
            {{ activity.what }}
          </td>
          <td>{{ activity.when }}</td>
        </tr>
        <tr v-if="user_activities.length === 0" class="empty-row">
          <td colspan="2">
            {{$t('account_settings.company_user_activity.no_activity')}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    computed: {
      user_activities() {
        return []
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../../styles/user_profile"
</style>
